<template>
  <div class="appSetting">
    <el-card class="box-card">
      <el-form
        ref="setRuleForm"
        :rules="rules"
        label-width="160px"
        :model="settingForm"
        inline-message
      >
        <el-form-item :label="this.$t('developer.pushDerail')">
          <el-switch
            v-model="settingForm.pushDerail"
            active-color="#13ce66"
            inactive-color="#cccccc"
          ></el-switch>
          <el-tooltip
            class="item"
            effect="dark"
            placement="bottom"
            style="margin-left:10px"
          >
            <div slot="content">{{ $t('developer.pushIntroduce') }}</div>
            <i class="el-icon-info" style="color:#606266"></i>
          </el-tooltip>
        </el-form-item>
        <template v-if="settingForm.pushDerail === true">
          <div class="divider_cla">
            <div class="el-divider__text">
              {{ $t('developer.serviceConfig') }}
            </div>
          </div>
          <el-form-item
            prop="url"
            :class="iSurlEg ? 'successCla' : ''"
            :label="this.$t('developer.url')"
          >
            <el-input
              style="width:400px"
              :placeholder="$t('developer.urlEg')"
              v-model="settingForm.url"
              autocomplete="off"
              @change="validateField"
            >
              <el-button
                class="resetAppSecret_cla"
                slot="append"
                @click="validateField"
                >{{ $t('developer.validateUrl') }}</el-button
              >
            </el-input>
            <span v-if="iSurlEg" style="color:@themeColor;margin-left:10px;">
              {{ message }}
            </span>
          </el-form-item>

          <el-form-item prop="token" :label="this.$t('developer.token')">
            <el-input
              style="width:400px"
              v-model="settingForm.token"
              autocomplete="off"
              :placeholder="this.$t('developer.tokenPla')"
            >
              <el-button
                class="resetAppSecret_cla"
                slot="append"
                @click.stop="createToken"
                >{{ $t('developer.randomCode') }}</el-button
              >
            </el-input>
            <el-tooltip
              class="item"
              effect="dark"
              placement="bottom"
              style="margin-left:10px"
            >
              <div slot="content">{{ $t('developer.randomNote') }}</div>
              <i class="el-icon-info" style="color:#606266"></i>
            </el-tooltip>
          </el-form-item>

          <el-form-item :label="this.$t('developer.aesStatus')">
            <el-switch
              v-model="settingForm.aesStatus"
              active-color="#13ce66"
              inactive-color="#cccccc"
            ></el-switch>
          </el-form-item>

          <template v-if="settingForm.aesStatus">
            <el-form-item prop="aesKey" :label="this.$t('developer.aeskey')">
              <el-input
                style="width:400px;"
                v-model="settingForm.aesKey"
                autocomplete="off"
                :placeholder="this.$t('developer.aeskeyPla')"
                disabled
              >
                <el-button
                  class="resetAppSecret_cla"
                  slot="append"
                  @click.stop="createAesKey"
                  >{{ $t('developer.randomCode') }}</el-button
                >
              </el-input>
              <el-tooltip
                class="item"
                effect="dark"
                placement="bottom"
                style="margin-left:10px"
              >
                <div slot="content">{{ $t('developer.randomNote16') }}</div>
                <i class="el-icon-info" style="color:#606266"></i>
              </el-tooltip>
            </el-form-item>
          </template>

          <div class="divider_cla">
            <div class="el-divider__text">
              {{ $t('developer.eventTypeArray') }}
            </div>
          </div>
          <el-row>
            <el-col :offset="1">
              <el-collapse v-model="activeName">
                <template v-for="item in pushTypeData">
                  <el-collapse-item
                    :name="item.name"
                    :key="item.name"
                    class="collapse-item-cla"
                  >
                    <template slot="title">
                      <span class="collapse-block-cla"></span>
                      <el-checkbox
                        :indeterminate="item.isIndeterminate"
                        v-model="item.isCheckAll"
                        @change="handleCheckAllChange(item)"
                      >
                        <span class="collapse-title-cla">{{ item.name }}</span>
                      </el-checkbox>
                    </template>
                    <div class="push_item_cla">
                      <template v-for="o in item.list">
                        <div :key="o.sid" class="push_item">
                          <div class="push_item_title">
                            <span
                              style="width:280px;overflow: hidden;text-overflow: ellipsis;"
                              >{{ o.name }}</span
                            >
                            <el-checkbox
                              v-model="o.isCheck"
                              @change="checkedEvent(o)"
                              :disabled="o.status === 0 ? true : false"
                            ></el-checkbox>
                          </div>
                          <div class="push_item_des_cla">
                            {{ $t('developer.pushDes') }} {{ o.description }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </el-collapse-item>
                </template>
              </el-collapse>
            </el-col>
          </el-row>
          <el-form-item>
            <!-- 数据推送类型 -->
          </el-form-item>
        </template>
      </el-form>
      <div style="width:100%;text-align:center">
        <el-button
          type="primary"
          @click.stop="submitSetting"
          style="color:#fff"
          >{{ $t('common.confirm') }}</el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script>
import { getRandomCode } from '@/utils/utils.js'
import { Loading } from 'element-ui'
import {
  findSettingDetail,
  saveOrUpdateSetting,
  testUrl,
  getConfigType
} from '@/services/appManagerApi.js'
import { getByType } from '@/cdpBase/services/dictionary.js'
export default {
  data() {
    let checkUrl = (rule, value, callback) => {
      this.iSurlEg = false
      if (!value) {
        return callback(new Error(this.$t('developer.urlTip')))
      } else {
        const urlregex = /^(https?|ftp|http):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
        if (!urlregex.test(value)) {
          return callback(new Error(this.$t('developer.urlTip')))
        }
        let params = {
          url: value,
          appKey: this.settingForm.appKey,
          token: this.settingForm.token
        }
        testUrl(params)
          .then(data => {
            if (data.code === '00000000') {
              if (data.message === undefined || data.message === null) {
                data.message = 'success!'
              }
              this.message = data.message
              this.iSurlEg = true
              return callback()
            } else {
              return callback(data.message)
              // return callback()
            }
          })
          .catch(e => {
            return callback(new Error(this.$t('common.requestServiceError')))
            // return callback()
          })
      }
    }
    return {
      rules: {
        url: [{ required: true, validator: checkUrl, trigger: 'blur' }]
      },
      eventType: [],
      checkEvent: [],
      orginEventType: [],
      iSurlEg: false,
      settingForm: {
        name: '',
        appKey: '',
        appSecret: '',
        pushDerail: true,
        url: '',
        token: '',
        aesKey: '',
        aesStatus: true
      },
      message: '',
      isColor: false,
      activeName: [],
      pushTypeList: [],
      pushTypeData: []
    }
  },
  props: {
    appInfo: {
      type: Object,
      default: function() {
        return null
      }
    }
  },

  watch: {
    'appInfo.appKey': {
      handler: function(val, oVal) {
        if (val) {
          // this.getConfigType()
          this.findSettingDetail()
        }
      },
      deep: true
    }
  },

  mounted() {
    if (this.appInfo) {
      // this.getConfigType()
      this.findSettingDetail()
      this.getPushType()
    }
  },
  methods: {
    handleCheckAllChange(type) {
      let temp = JSON.parse(JSON.stringify(this.pushTypeData))
      temp.forEach(item => {
        if (item.value === type.value) {
          if (type.isCheckAll) {
            // 全选
            item.isIndeterminate = false
            item.isCheckAll = true
            item.list.forEach(k => {
              if (!k.status) {
                // 跳过禁用
                return
              }
              k.isCheck = true
            })
          } else {
            // 取消反选
            item.isIndeterminate = false
            item.isCheckAll = false
            item.list.forEach(k => {
              k.isCheck = false
            })
          }
        }
      })

      this.pushTypeData = temp
    },
    getPushType() {
      // 获取推送类型分类
      getByType('pushType')
        .then(data => {
          this.pushTypeList = data.results.results
          this.pushTypeData = data.results.results
          this.pushTypeList.forEach(item => {
            this.activeName.push(item.name) // 默认展开全部
          })
        })
        .catch(e => console.error('getPushType():', e))
    },

    checkedEvent(type) {
      // 回显选择checked
      let temp = JSON.parse(JSON.stringify(this.pushTypeData))
      temp.forEach(item => {
        item.list.forEach(k => {
          if (type.sid === k.sid) {
            // 是否选中
            if (type.isCheck) {
              k.isCheck = true
            } else {
              k.isCheck = false
            }
          }
        })
      })

      temp.forEach(item => {
        let count = 0 // 计算是否全选
        item.list.forEach(k => {
          if (k.isCheck) {
            count++
          }
        })
        if (count === item.list.length) {
          // 全选
          item.isIndeterminate = false
          item.isCheckAll = true
        } else if (count !== 0 && count < item.list.length) {
          // 半选
          item.isIndeterminate = true
          item.isCheckAll = false
        } else if (count === 0) {
          item.isIndeterminate = false
          item.isCheckAll = false
        }
      })

      this.pushTypeData = temp
    },
    validateField() {
      this.$refs.setRuleForm.validateField('url')
    },
    getConfigType() {
      if (!this.appInfo.appKey) {
        return false
      }
      let params = {
        status: '1',
        appKey: this.appInfo.appKey
      }
      this.checkEvent = []
      getConfigType(params)
        .then(data => {
          if (data.code === '00000000') {
            let pushTypeData = []
            let temp = data.payload.results
            let appCheckedPushData = data.payload.pushTypeList || []
            this.orginEventType = temp

            // 构造数据
            this.pushTypeList.forEach(item => {
              item.isCheckAll = false
              item.isIndeterminate = true
              item.list = [] // 类型数据
              item.checkList = [] // 选中的数据
              pushTypeData.push(item)
            })

            // 处理每种推送数据类型有多少数据
            temp.forEach(item => {
              item.dbsAppSettingPushTypeRef.forEach(type => {
                pushTypeData.forEach(pushType => {
                  if (pushType.value === type.sysDictionaryValue) {
                    item.isCheck = false
                    pushType.list.push(item)
                  }
                })
              })
            })

            // 处理每种推送类型数据有多少个是选中
            appCheckedPushData.forEach(checked => {
              pushTypeData.forEach(item => {
                item.list.some(k => {
                  if (k.sid === checked) {
                    k.isCheck = true
                  }
                })
              })
            })

            // 处理最终数据
            pushTypeData.forEach(item => {
              let count = 0
              item.list.forEach(k => {
                if (k.isCheck) {
                  count++
                }
              })
              if (count === item.list.length) {
                // 全选
                item.isIndeterminate = false
                item.isCheckAll = true
              } else if (count !== 0 && count < item.list.length) {
                // 半选
                item.isIndeterminate = true
                item.isCheckAll = false
              } else if (count === 0) {
                item.isIndeterminate = false
                item.isCheckAll = false
              }
            })
            this.pushTypeData = pushTypeData
          }
          this.closeLoad()
        })
        .catch(e => {})
    },

    submitSetting() {
      if (this.settingForm.url === '') {
        this.$refs.setRuleForm.validateField('url')
        return
      }

      let temp = []
      this.pushTypeData.forEach(item => {
        item.list.forEach(checked => {
          if (checked.isCheck) {
            temp.push(checked.sid)
          }
        })
      })

      this.$refs.setRuleForm.validate(valid => {
        let target = {}
        Object.assign(target, this.settingForm, {
          pushTypeList: [...new Set(temp)] // 去除重复的
        })
        target.pushDerail = target.pushDerail === true ? 1 : 0
        target.aesStatus = target.aesStatus === true ? 1 : 0
        this.showLoad()
        saveOrUpdateSetting(target)
          .then(data => {
            if (data.code === '00000000') {
              this.findSettingDetail()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => {
            this.errorMessage()
          })
          .finally(e => {
            this.closeLoad()
          })
        // }
      })
    },
    findSettingDetail() {
      if (!this.appInfo.appKey) {
        return false
      }
      let params = {
        appKey: this.appInfo.appKey
      }
      findSettingDetail(params)
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.results
            this.settingForm.name = result.name
            this.settingForm.appKey = result.appKey
            this.settingForm.appSecret = result.appSecret
            this.settingForm.pushDerail = result.pushDerail === 1
            this.settingForm.url = result.url
            this.settingForm.token = result.token
            this.settingForm.aesKey = result.aesKey
            this.settingForm.aesStatus = result.aesStatus === 1
            this.getConfigType()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage()
        })
      this.closeLoad()
    },

    createToken() {
      this.settingForm.token = getRandomCode()
    },
    createAesKey() {
      this.settingForm.aesKey = getRandomCode(16)
    },
    showLoad() {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('developer.saveTip'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    closeLoad() {
      if (this.loadingInstance) {
        setTimeout(() => {
          this.loadingInstance.close()
        }, 500)
      }
    }
  }
}
</script>

<style lang="less">
@import '~@/styles/var.less';
.appSetting {
  .el-input.is-disabled .el-input__inner {
    color: #606266;
  }
  .resetAppSecret_cla {
    cursor: pointer;
    color: #606266;
  }

  .divider_cla {
    display: block;
    height: 1px;
    width: 100%;
    margin: 24px 0;
    background-color: #dcdfe6;
    position: relative;
    .el-divider__text {
      position: absolute;
      background-color: #fff;
      padding: 0 20px;
      font-weight: 500;
      color: #303133;
      left: 20px;
      transform: translateY(-50%);
      font-size: 14px;
    }
  }
  .collapse-item-cla {
    margin-top: 15px;
    .collapse-block-cla {
      display: inline-block;
      width: 4px;
      height: 49px;
      margin-right: 10px;
      background: @themeColor;
    }
    .push_item_cla {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-top: 10px;
      .push_item {
        width: 300px;
        margin: 0 10px 10px 0;
        border: 1px solid @fontColor4;
        border-radius: 4px;
        line-height: 28px;
        padding: 10px;
        box-shadow: @boxShadow;
        .push_item_title {
          white-space: nowrap;
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          font-weight: 700;
        }
        .push_item_des_cla {
          overflow: hidden;
          text-overflow: ellipsis;
          color: @fontColor3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; // 行数
        }
      }
    }
  }

  .successCla {
    .el-input__inner,
    .el-input__inner:hover {
      border-color: #67c23a;
    }

    .el-form-item__error {
      color: #67c23a;
    }
    .el-message-box__input input.invalid:focus {
      border-color: #67c23a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting/appSetting.vue